import { render, staticRenderFns } from "./InputGo.vue?vue&type=template&id=59949c0e"
import script from "./InputGo.vue?vue&type=script&lang=js"
export * from "./InputGo.vue?vue&type=script&lang=js"
import style0 from "./InputGo.vue?vue&type=style&index=0&id=59949c0e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports